import { compareShallowObject } from '../../utils/comparators.js';
import deletionRegistry from '../../utils/DeletionRegistry.js';
import useComparableEffect from '../../utils/useComparableEffect.js';
import useGetterRef from '../../utils/useGetterRef.js';
import useUnmount from '../../utils/useUnmount.js';

/**
 * Returns a mapper getter.
 */
function useMapper(constructor, props, trackModified) {
    const [mapperRef, getMapper] = useGetterRef(() => {
        const m = constructor();
        deletionRegistry.register(m, () => m.delete());
        return m;
    });
    useComparableEffect(() => {
        if (!props)
            return;
        trackModified(getMapper().set(props));
    }, [props], ([cur], [prev]) => compareShallowObject(cur, prev));
    useUnmount(() => {
        if (mapperRef.current) {
            deletionRegistry.markForDeletion(mapperRef.current);
            mapperRef.current = null;
        }
    });
    return getMapper;
}

export { useMapper as default };
